import { AxiosInstance } from 'axios';
import { Notification } from 'referral-types';
import { simulate } from './utils';

export const baseEndpoint = 'notification';

export class NotificationApi {
  private apiInstance: AxiosInstance;

  constructor(apiInstance: AxiosInstance) {
    this.apiInstance = apiInstance;
  }

  async getAllNotificationsForUser(): Promise<Array<Notification>> {
    await simulate();
    const response = await this.apiInstance.get('/');

    return response.data; 
  }

  async getUnreadNotificationsForUser(): Promise<Array<Notification>> {
    await simulate();
    const response = await this.apiInstance.get('/unread');

    return response.data; 
  }

  async markAllAsRead(): Promise<Array<void>> {
    await simulate();
    const response = await this.apiInstance.put('/mark-all-read');

    return response.data; 
  }
}
